import { render, staticRenderFns } from "./table-dialog-store.component.vue?vue&type=template&id=4a5be3d8&scoped=true"
import script from "./table-dialog-store.component.vue?vue&type=script&lang=ts"
export * from "./table-dialog-store.component.vue?vue&type=script&lang=ts"
import style0 from "./table-dialog-store.component.vue?vue&type=style&index=0&id=4a5be3d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5be3d8",
  null
  
)

export default component.exports